import { forwardRef } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Heading } from '@frontend/design-system';
import { Props, SlotsProps, TitleProps } from '../types';

export const HeaderStart = ({ css, children, ...rest }: SlotsProps) => {
  return (
    <div
      css={[
        {
          display: 'flex',
          alignItems: 'center',
          gap: theme.spacing(1),
          flexShrink: 0,
        },
        css,
      ]}
      {...rest}
    >
      {children}
    </div>
  );
};

export const HeaderTitle = ({ titlePostFixIcon, children, ...rest }: TitleProps) => {
  return (
    <Heading
      level={3}
      css={{
        display: 'flex',
        alignItems: 'center',
        lineHeight: theme.spacing(3),
        padding: `${theme.spacing(0.75)} ${theme.spacing(0.5)}`,
        whiteSpace: 'nowrap',
      }}
      {...rest}
    >
      {children}
      {titlePostFixIcon && <Icon css={{ marginLeft: theme.spacing(1) }} name={titlePostFixIcon} size={12} />}
    </Heading>
  );
};

export const HeaderActions = ({ children, ...rest }: SlotsProps) => {
  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: ${theme.spacing(1.5)};
        flex-shrink: 0;
        margin-left: auto;
      `}
      {...rest}
    >
      {children}
    </div>
  );
};

export const InteractiveButton = forwardRef<HTMLButtonElement, Props>(
  ({ children, trackingId, type = 'button', ...rest }, ref) => (
    <button
      css={css`
        background: none;
        border: none;
        cursor: pointer;
        font-size: ${theme.fontSize(20)};
        font-weight: ${theme.font.weight.bold};
        padding: 0;
        display: flex;
        gap: ${theme.spacing(1)};
      `}
      data-trackingid={trackingId}
      type={type}
      {...rest}
      ref={ref}
    >
      {children}
    </button>
  )
);
